import { useState, useEffect } from "react";
import { getVersion } from "../../services/version.api";

// Obtiene la versión + fecha de instalación del proveedor Baileys desde /version
// (una sola vez por montaje de la página). Devuelve null hasta que responde.
export default function useBaileysVersion() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await getVersion();
        if (mounted) setInfo(data);
      } catch (_) {
        // informativo: si falla, las tarjetas simplemente no muestran versión
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return info; // { baileysVersion, baileysUpdatedAt, ... } | null
}
